var e = {
	header: {
		messages: "Messages",
		notifications: "Notifications"
	},
	tabs: { guest: {
		home: "Home",
		trips: "Trips",
		messages: "Messages",
		account: "Account",
		signIn: "Sign in"
	} },
	globalSearch: { placeholder: "Search bookings, listings, chats…" },
	drawer: {
		openMenu: "Open navigation menu",
		quickActions: "Quick actions",
		owner: "Owner",
		host: "Host",
		switchWorkspace: "Switch workspace",
		switchWorkspaceError: "Couldn't switch workspace. Please try again.",
		discover: "Discover",
		popularDestinations: "Popular destinations",
		resources: "Resources",
		mapSearch: "Map Search",
		mapSearchDescription: "Find stays in specific areas",
		travelGuides: "Travel Guides",
		travelGuidesDescription: "Local tips from the hosts who live there",
		popularAmenities: "Popular amenities",
		popularTypes: "Popular types",
		exploreDestination: "Explore {{name}}",
		findStaysWith: "Find stays with {{amenity}}",
		browseTypeStays: "Browse {{type}} stays",
		becomeHost: "Become a Host",
		becomeHostDescription: "Earn money doing what you love.",
		becomeHostAction: "Setup"
	},
	navItems: {
		soon: "Soon",
		guest: {
			kinds: "Browse by kind",
			home: "Home",
			explore: "Explore",
			favorites: "Favorites",
			experiences: "Experiences",
			services: "Services"
		},
		host: {
			home: "Home",
			dashboard: "Dashboard",
			actions: "Action Center",
			properties: "Properties",
			allProperties: "All Properties",
			addProperty: "Add Property",
			propertyGroups: "Property Groups",
			experiences: "Experiences",
			services: "Services",
			bookingRules: "Booking Rules",
			pricingRules: "Pricing Rules",
			ratesAndAvailability: "Rates & Availability",
			bookings: "Bookings",
			messages: "Messages",
			reservations: "Reservations",
			calendar: "Calendar",
			frontDesk: "Front desk",
			frontDeskToday: "Today",
			roomType: "Room type",
			room: "Room",
			coupons: "Coupons",
			travelGuides: "Travel Guides",
			finance: "Finance",
			earnings: "Earnings",
			withdrawals: "Withdrawals",
			penalties: "Penalties",
			withdrawalMethods: "Withdrawal Methods",
			workspace: "Workspace",
			members: "Members",
			roles: "Roles",
			settings: "Settings",
			developer: "Developer",
			developerOverview: "Overview",
			developerKeys: "API keys",
			developerWebhooks: "Webhooks",
			developerLogs: "Logs",
			developerSandbox: "Sandbox"
		}
	},
	profileMenu: {
		switchToTravelling: "Switch to Travelling",
		switchToHosting: "Switch to Hosting",
		accountSettings: "Account Settings",
		helpAndSupport: "Help & Support",
		trips: "Trips",
		messages: "Messages",
		creatorPortal: "Creator Portal",
		language: "Language",
		currency: "Currency",
		logInOrSignup: "Log in or signup",
		helpCenter: "Help center",
		logout: "Logout",
		guest: "Guest",
		userProfileAlt: "User Profile",
		switchToTravellingError: "Could not switch to travelling",
		switchToHostingError: "Could not switch to hosting"
	},
	languageModal: {
		title: "Language",
		saveError: "Failed to save language preference"
	},
	currencyModal: {
		title: "Currency",
		updated: "Currency updated",
		updatedDescription: "Display currency set to {{currency}}",
		updateError: "Failed to update currency",
		disclaimer: "All payments are captured in EGP. Additional bank fees may apply if your card's currency is different."
	},
	impersonation: {
		banner: "Impersonating as admin ({{email}})",
		bannerReadOnly: "Impersonating as admin ({{email}}) · read-only",
		stop: "Stop impersonating"
	}
};
//#endregion
export { e as default };
